import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';
import { PromoItem, PromoItemType } from '../../Common/PromoItem/PromoItem.es.js';
import { BlockHeader } from '../../mobile/BlockHeader/BlockHeader.es.js';

const PartOrderGiftWrapper = styled.div`
  padding: 16px;
  background: #fff;
`;
const StyledBlockHeader = styled(BlockHeader)`
  background: #f6f6f6;
`;
const StyledPromoItem = styled(PromoItem)`
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
const OrderPromotion = ({
  orderPromotions,
  isMobile = false
}) => {
  let promotions = [];
  orderPromotions.forEach((promotion) => {
    if (promotion) {
      const { discount, gifts, voucher, quantity } = promotion;
      if (discount)
        promotions.push({
          text: t("{{quantity}}x Gi\u1EA3m gi\xE1 {{var0}}", {
            quantity,
            var0: (discount / quantity).toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND"
            })
          }),
          type: PromoItemType.DISCOUNT
        });
      if (gifts == null ? void 0 : gifts.length) {
        promotions = [
          ...promotions,
          ...gifts.map((gift) => ({
            text: `${gift.quantity}x ${gift.name}`,
            type: PromoItemType.GIFT,
            imgSrc: gift.imageUrl || ""
          }))
        ];
      }
      if (voucher == null ? void 0 : voucher.quantity)
        promotions.push({
          type: PromoItemType.VOUCHER,
          text: t("{{VoucherQuantity}}x Voucher gi\u1EA3m gi\xE1 cho \u0111\u01A1n h\xE0ng sau", {
            VoucherQuantity: voucher.quantity
          })
        });
    }
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && /* @__PURE__ */ React.createElement(StyledBlockHeader, {
    title: {
      fontWeight: "500",
      fontSize: 14,
      color: "#848788"
    }
  }, t("KHUY\u1EBEN M\xC3I CHO \u0110\u01A0N H\xC0NG")), /* @__PURE__ */ React.createElement(PartOrderGiftWrapper, null, promotions.map(({ type, text, imgSrc }, index) => type !== PromoItemType.DISCOUNT && /* @__PURE__ */ React.createElement(StyledPromoItem, {
    key: index,
    type,
    text,
    imgSrc
  }))));
};

export { OrderPromotion };
